import axios from "axios";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from 'react-query';
import * as config from "../../../app.config";
import { plateTypes } from "../../constants/plateTypes";


const getAllSerialNumbers = async (type) => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/list/serial_numbers`, {
        headers: headerConfig
    });
    const uniqueSerialNumbers = [...new Set(data?.data?.map(item => item.serial_number))];

    return uniqueSerialNumbers;
};
export default function useFetchSerialNumbers(type) {

    return useQuery('serialNumbers', () => getAllSerialNumbers(), {
        // enabled: type === plateTypes.mfg,

        onSuccess: (data) => {

            //console.log(data);
        },

        onError: (error) => {

            //console.log(error);
        },

    });






};

